const SECONDS_PER_DAY = 1000 * 60 * 60 * 24;

export const dateIsBeforeNow = (date: Date): boolean => new Date(date).getTime() > (new Date().getTime() - SECONDS_PER_DAY);

export const nowTillDate = (date) => Math.ceil(((new Date(date)).getTime() - (new Date()).getTime()) / SECONDS_PER_DAY) + 1;
